import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import LoadingView from '../loading/LoadingView';
import Button from '@mui/material/Button';
import { updateOperation } from '../../api/operations';
import { setAlert } from '../../helpers/alerts';
import { Stack } from '@mui/material';
import { name_for_op } from '../../helpers/ops_names';

let ops_sort = (a, b) => {
    if (a.start_date < b.start_date) {
        return 1;
    }
    if (a.start_date > b.start_date) {
        return -1;
    }
    return 0;
};

export default function SimpleOperationsList(props) {
    const { operations, loaded, error, reloadData, onOpClick } = props;
    const [rows, setRows] = React.useState([]);
    
    const actionsFor = (r) => {
        switch (r.status) {
            case 'running':
                return (
                    <Stack>
                    <Button variant="outlined" color="info" onClick={() => handleAction(r.uuid, "pause")}>Pause</Button>
                    </Stack>
                );
            case 'pending':
                return (
                    <div>
                    <Button variant="outlined" color="error" onClick={() => handleAction(r.uuid, "cancel")}>Cancel</Button>
                    </div>
                );
            case 'paused':
                return (
                    <div>
                    <Button variant="outlined" color="error" onClick={() => handleAction(r.uuid, "cancel")}>Cancel</Button>
                    </div>
                );
            case 'cancelled':
                return (
                    <div>
                    <Button variant="outlined" color="error" onClick={() => handleAction(r.uuid, "delete")}>Delete</Button>
                    </div>
                );
            case 'errored':
                return (
                    <div>
                    <Button variant="outlined" color="success" onClick={() => handleAction(r.uuid, "rerun")}>Retry</Button>
                    </div>
                );
            default:
                return (<div></div>);
        }
    }
    const handleAction = (uuid, action) => {
        updateOperation(uuid, action).then((r) => {
            if (reloadData) {
                reloadData();
            }
            setAlert(`${action}d`, `Operation "${r.operation}"`, 'success');
        }
        ).catch((e) => {
            setAlert('Error', e, 'danger');
        });
    };
    const handleRowClick = (r) => {
        if (onOpClick) {
            onOpClick(r);
        }
    };

    React.useEffect(() => {
        if (loaded) {
            setRows(operations);
        }
    }, [operations, loaded, error]);

    
    if (!loaded) {
        return <div style={{display: 'flex', justifyContent: 'center'}}><LoadingView title="Loading operations" /></div>
    }
    if (error) {
        return <div>Error loading operations: {error}</div>
    }
    if (rows.length === 0) {
        return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 100}}>No operations</div>
    }

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Operation</TableCell>
            <TableCell>Stage</TableCell>
            <TableCell>Started</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.sort(ops_sort).map((row) => (
            <TableRow
              key={row.uuid}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row" onClick={()=>handleRowClick(row)}>
                { name_for_op((row.metadata && row.metadata.display_step) ? row.metadata.display_step : row.metadata.step) }
              </TableCell>
              <TableCell>{row.metadata.stage}</TableCell>
              <TableCell>{row.start_date.replace("T", " ").substr(0,19)}</TableCell>
              <TableCell>{row.status}</TableCell>
              <TableCell>{actionsFor(row)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
